import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconShareExport = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.693 2.06568C11.7866 2.02381 11.8903 2.00054 11.9994 2.00053C12.1042 2.00054 12.204 2.02199 12.2946 2.06074C12.3797 2.09705 12.4594 2.14978 12.529 2.21894L12.5306 2.22054L16.7795 6.46943C17.0728 6.76276 17.0728 7.23833 16.7795 7.53166C16.4861 7.82498 16.0106 7.82498 15.7172 7.53166L12.7506 4.56498V15.9983C12.7506 16.4132 12.4143 16.7494 11.9994 16.7494C11.5846 16.7494 11.2483 16.4132 11.2483 15.9983L11.2483 4.56499L8.28167 7.53166C7.98834 7.82499 7.51277 7.82499 7.21944 7.53166C6.92612 7.23834 6.92612 6.76276 7.21945 6.46944L11.4683 2.22054C11.4795 2.20934 11.491 2.19857 11.5027 2.18822L11.693 2.06568Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.75 14C4.75 13.3096 5.30964 12.75 6 12.75H7.5C7.91421 12.75 8.25 12.4142 8.25 12C8.25 11.5858 7.91421 11.25 7.5 11.25H6C4.48122 11.25 3.25 12.4812 3.25 14V19C3.25 20.5188 4.48122 21.75 6 21.75H18C19.5188 21.75 20.75 20.5188 20.75 19V14C20.75 12.4812 19.5188 11.25 18 11.25H16.5C16.0858 11.25 15.75 11.5858 15.75 12C15.75 12.4142 16.0858 12.75 16.5 12.75H18C18.6904 12.75 19.25 13.3096 19.25 14V19C19.25 19.6904 18.6904 20.25 18 20.25H6C5.30964 20.25 4.75 19.6904 4.75 19V14Z",
		fill: "currentColor"
	})]
});
export { SvgIconShareExport as ReactComponent };
